import React, { useEffect, useMemo, useRef, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { Box, ComboboxData, Grid, Group, Space, Stack } from '@mantine/core';
import Card from '../../components/elements/Card';
import { useQuery } from '@tanstack/react-query';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './style.scss'
import { Button } from '@mantine/core';
import {Row, Col, FormGroup, Label, Badge , Input, Container} from "reactstrap";
import Select from 'react-select';
import {DatePickerInput, DateTimePicker } from '@mantine/dates';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import {
    getDelegationUnit,
    getEmployee,
    getTaskDelegation,
    getTaskType,
    editTaskDelegation,
    detail
  } from '../../services/taskDelegation';
import { useMutation } from '@tanstack/react-query';
import moment from 'moment';
import { time } from 'console';
import { times, toNumber } from 'lodash';
import { showNotification } from '../../utilities/mantineNotification';



const EditTaskDelegation = (props) => {

    const binusianId = props.auth.binusianId  
    // //Testing
    // const fullName = "Ronald Kimberly"
    // const emailTesting = 'RonaldKimberly@binus.edu'
    // const binusianIdTesting = "1100015136"

  
    
    //TaskType
    const [taskType, setTaskType] = useState({category: '', code: '0', description1: ''})
    const [type, setType] = useState<ComboboxData>([]);
    const [selectedTaskType, setSelectedTaskType] = useState<any>('')

    //Unit
    const [selectedunitName, setSelectedUnitName] = useState<any>("")
    const [unit, setUnit] = useState<ComboboxData>([]) 
    const [unitType, setUnitType] = useState({kodeDep: '', NamaDep: ""})

    //Employee
    const [selectedpeopleName, setSelectedPeopleName] = useState('')
    const [employee, setEmployee] = useState({id: '', name: "", email: "", position: ""})
    const [employees, setEmployees] = useState([])
    const prevSelectedPeople = useRef('')
    const [employeeFlag, setEmployeeFlag] = useState(false)


    const [filteredQuery, setFilteredQuery] = useState([])
    const [position, setPosition] = useState('')

    //Dates
    const [startDateTime, setStartDateTime] = useState(new Date());
    const [endDateTime, setEndDateTime] = useState(new Date());
    const [started, setStarted] = useState(false)


    const [employeeId, setEmployeeId] = useState('')
    const [employeeName, setEmployeeName] = useState('')
    const [employeeEmail, setEmployeeEmail] = useState('')
    const [modalDialog, setModalDialog] = useState({ 
        opened: false,
        data: null,
        type: ''
    });
    const [nameflag, setNameFlag] = useState(false)
    const [requestBody, setRequestBody] = useState({ BinusianID: binusianId });
    // const [requestBody, setRequestBody] = useState({ BinusianID: binusianIdTesting});

    const [binusianName, setBinusianName] = useState('test')

    const [reasonUpdate, setReasonUpdate] = useState("")
    const [error, setError] = useState('')

    const [updatedPeople, setUpdatedPeople] = useState("")

    //fetchtasks
    const fetchMasterTask = useQuery({
        queryKey: ['getTaskDelegation'],
        queryFn:  () =>
            getTaskDelegation({
                // BinusianID : binusianIdTesting,
                BinusianID : binusianId,
                page: 1,
                take: 10
            })
           
    }) 

    //FetchOldTaskDetail
    const fetchDetailTask = useQuery({
        queryKey: ['detail'],
        queryFn: () =>
            detail({
                id: props.location.state.updateTaskId
            })
            .then((resp) => {
                // console.log(resp)
                const _data = resp.data.data.map(item => ({
                    Id : item.id,
                    BinusianId: item.binusianId,
                    BinusianIdDelegate: item.binusianIdDelegate,
                    BuCode: item.buCode,
                    BuName: item.buName,
                    CreatedEmail: item.createdEmail,
                    CreatedName: item.createdName,
                    DateIn: item.dateIn,
                    DateUp: item.dateUp,
                    DeptCode: item.deptCode,
                    DeptName: item.deptName,
                    Email: item.email,
                    EmailDelegate: item.emailDelegate,
                    EndDate: item.endDate,
                    GroupBuCode: item.groupBuCode,
                    GroupBuName: item.groupBuName,
                    IsDeleted: item.isDeleted,
                    LvDep: item.lvDep,
                    Name: item.name,
                    NameDelegate: item.nameDelegate,
                    RevokedBinusianId: item.revokedBinusianId,
                    RevokedEmail: item.revokedEmail,
                    RevokedName: item.revokedName,
                    RevokedReason: item.revokedReason,
                    SectionCode: item.sectionCode,
                    SectionName: item.sectionName,
                    StartDate: item.startDate,
                    SubBuCode: item.subBuCode,
                    Status: item.status,
                    SubName: item.subName,
                    TaskCode: item.taskCode,
                    UpdateName: item.updateName,
                    UpdatedEmail: item.updatedEmail,
                    UpdatedReason: item.updatedReason,
                    UserIn: item.userIn,
                    UserUp: item.userUp,
                    IsStarted: item.isStarted
                }))
                // console.log(_data[0].TaskCode)
                // console.log(_data)
                if(_data[0].TaskCode === '001'){
                    const _type = {value : '001', label : 'External Training'}
                    setSelectedTaskType(_type)
                }else if(_data[0].TaskCode === '002'){
                    const _type = {value: '002', label : 'Self Report'}
                    setSelectedTaskType(_type)
                }else if(_data[0].TaskCode === '003'){
                    const _type = {value: '003', label : 'Training Need Analysis (TNA)'}
                    setSelectedTaskType(_type)
                }
                setSelectedPeopleName(_data[0].NameDelegate)
                setUpdatedPeople(_data[0].NameDelegate)
                const _unit = {value: _data[0].DeptCode, label: _data[0].DeptName}
                setSelectedUnitName(_unit)
                // setStartDateInput(moment(_data[0].StartDate).toDate())
                // const [day, month, year] = moment(_data[0].StartDate).format('DD/MM/YYYY').split('/');
                // const dateStart =`${year}-${month}-${day}`;
                // const timeStart = moment(_data[0].StartDate).format('HH:mm')
                // setStartDateInput(dateStart)
                // setStartTimeInput(timeStart)
                // setStartDate(dateStart)
                // setStartTime(timeStart)
                // const [day1, month1, year1] = moment(_data[0].EndDate).format('DD/MM/YYYY').split('/');
                // const dateEnd =`${year1}-${month1}-${day1}`;
                // const timeEnd = moment(_data[0].EndDate).format('HH:mm')
                // setEndDateInput(dateEnd)
                // setEndTimeInput(timeEnd)
                // setEndDate(dateEnd)
                // setEndTime(timeEnd)
                // const resultSD = formatDate(_data[0].StartDate);
                // const resultED = formatDate(_data[0].EndDate);
                const fetchedStartDate = _data[0].StartDate ? new Date(_data[0].StartDate) : null;
                const fetchedEndDate = _data[0].EndDate ? new Date(_data[0].EndDate) : null;
                setStartDateTime(fetchedStartDate);
                setEndDateTime(fetchedEndDate);
                if(_data[0].IsStarted == true){
                    setStarted(true)
                }
                setEmployeeEmail(_data[0].EmailDelegate)
                setEmployeeId(_data[0].BinusianIdDelegate)
                setEmployeeName(_data[0].NameDelegate)
                setReasonUpdate(_data[0].UpdatedReason)
            })
    })

    useEffect(() => {
        // console.log(selectedTaskType)
        // console.log(selectedpeopleName)
        // console.log(selectedunitName)
        if(!selectedTaskType || !updatedPeople || !selectedunitName){
            fetchDetailTask.refetch()
        }
        if(!position){
            setEmployeeFlag(true)
            fetchEmployee.refetch()
        }
    }, [fetchDetailTask])
   



    //FetchType
    const fetchTaskType = useQuery({
     queryKey: ['getTaskType'],
     queryFn: () =>
       getTaskType()
       .then((resp) => {
         const data = resp.data.data.map(item =>({
           category : item.category,
           code: item.code,
           description1 : item.description1
         }))
         setType(data)
       })
  
    });
    
    useEffect(() => {
      if (taskType?.code || taskType?.code || taskType?.description1) {
          fetchTaskType.refetch;
        }
    }, [taskType, fetchTaskType]);
    
    const optionsTaskType = type.map(item => ({
      value: item.code,
      label: item.description1
    }));


    //FetchUnit
    const fetchUnitDel = useQuery({
        queryKey: ['getDelegationUnit', requestBody],
        queryFn: () =>
        getDelegationUnit(requestBody.BinusianID)
        .then((resp) => {
            // console.log('API Response:', resp);
            if (resp.data) {
                const data = resp.data.data.map(item => ({
                    kodeDep: item.kodeDep,
                    NamaDep: item.namaDep 
                }));
                // console.log('Mapped Data:', data);
                setUnit(data);
            } else {
                console.error('Invalid response format:', resp);
            }
        })
    })

    useEffect(() => {
    //   console.log(unit)  
    if(requestBody.BinusianID || unitType?.NamaDep || unitType?.kodeDep){
        fetchUnitDel.refetch;
    }
    }, [requestBody.BinusianID, fetchUnitDel])

    const optionsUnitType = unit.map(item => ({
        value: item.kodeDep,
        label: item.NamaDep
    }))


    //FetchEmployee
    const fetchEmployee = useQuery({
        queryKey: ['getEmployee'],
        queryFn: () => 
            // getEmployee({BinusianID : binusianIdTesting , keyword : selectedpeopleName})
            getEmployee({BinusianID : binusianId , keyword : selectedpeopleName})
        .then((resp) => {
            // console.log(resp.data)
            // console.log(selectedpeopleName)
            const _data = resp.data.data.map(item => ({
                id : item.binusianId,
                name : item.name,
                email : item.email,
                position : item.position
            }))
            setEmployees(_data)
            if(employeeFlag){
                setEmployees(_data)
                // console.log(_data)
                if(_data[0].position){
                    setPosition(_data[0].position)
                }
            }
            // console.log("employees")
            
        })
    })

    useEffect(() => {
        if (selectedpeopleName && prevSelectedPeople.current !== selectedpeopleName) {
            fetchEmployee.refetch();
            prevSelectedPeople.current = selectedpeopleName;
        }
    }, [selectedpeopleName, fetchEmployee]);

    // useEffect(() => {
    //     if(employeeFlag){
    //         fetchEmployee.refetch()
    //         // if(employees){
    //         //     // setPosition(employees.position)
    //         // }
    //         setEmployeeFlag(false)
    //     }
    // }, [selectedpeopleName, employeeFlag, fetchEmployee])
   


    const editTask = useMutation({
        mutationFn: editTaskDelegation,
        
        onSuccess: (response) => {
            
            handleCloseModal();
            // console.log(response.status)
            const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;

            if(response.status == 2){

                showNotification({
                    type: 'error',
                    message: parsedResponse.message
                });
            }else{
                fetchMasterTask.refetch();
                console.log("success")
                location.href = '/task-delegation'
            }
                
            
        },
        onError: (error) => {
            console.log(error)
            showNotification({
                type: 'error',
                message: JSON.stringify(error)
            });
            // console.log("error")
        }
    })
    




    const handleTaskSelect = (selected) =>{
        setSelectedTaskType(selected);
        // console.log(selected)
    }


    const handleUnitSelect = (selected) =>{
        // console.log("unit")
        // console.log(selected)
        setSelectedUnitName(selected);
    }




    const handleSubmitData = (data) => {
        if (reasonUpdate.trim() === '') {
            setError('Reason is required');
            return;
        }
            setModalDialog({
                opened: true,
                data: null,
                type: 'submission'
            });

    };


    const handleReason = (query) => {
        if(query == ''){
            setReasonUpdate('')
            setError('Reason is required');
            return
        }
        setReasonUpdate(query)
        setError('')
    }

    // const getUserName = () => {
        

    // }

    

    const handleSave = () => {
        // console.log(props.location.state.updateTaskId)
        // const tempStart = `${startDate}T${startTime}:00`;
        // const localDateSt = new Date(tempStart);
        // const sDate = new Date(localDateSt.getTime() - localDateSt.getTimezoneOffset() * 60000).toISOString();
        // const tempEnd = `${endDate}T${endTime}:00`;
        // const localDateEn = new Date(tempEnd)
        // const eDate = new Date(localDateEn.getTime() - localDateEn.getTimezoneOffset() * 60000).toISOString()
        const localDateSt = new Date(startDateTime);
        const localDateEn = new Date(endDateTime);
        const sDate = new Date(localDateSt.getTime() - localDateSt.getTimezoneOffset() * 60000).toISOString();
        const eDate = new Date(localDateEn.getTime() - localDateEn.getTimezoneOffset() * 60000).toISOString();
        const data = {
            Id : props.location.state.updateTaskId,
            // BinusianID: binusianIdTesting,
            BinusianID: binusianId,
            BinusianName: props.auth.fullName,
            // BinusianName: fullName,
            Email: props.auth.email,
            // Email: emailTesting,
            EmailDelegate: employeeEmail,
            TaskCode: selectedTaskType.value,
            UnitDelegatedId: selectedunitName.value,
            UnitDelegatedName: selectedunitName.label,
            DelegatedBinusianId: employeeId,
            DelegatedBinusianName: employeeName,
            StartDate: sDate,
            EndDate: eDate,
            UserUp: binusianId,
            // UserUp: binusianIdTesting,
            UpdatedReason : reasonUpdate,
            // UpdateName : fullName,
            UpdateName : props.auth.fullName,
            UpdatedEmail :props.auth.email,
            // UpdatedEmail :emailTesting,
            IsDeleted: false
        }

        try {
            editTask.mutate(data)
            

        } catch (error) {
            console.error('Error updating task delegation:', error);
        }
    }

    const handleCloseModal = () => {
        setModalDialog({
        opened: false,
        data: null,
        type: ''
        });
    };


      const handleSearchPeople = (query) =>{
        // console.log(employees)
        if(query == ''){
            setSelectedPeopleName('')
            setFilteredQuery([])
            setNameFlag(false)
            return
        }
        setSelectedPeopleName(query)
        if(query && employees){
            setFilteredQuery(employees);
            setNameFlag(true)
            }
        
        return
    }
    
    const handleKeyDownSearch = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchPeople(selectedpeopleName);
            employees.map((item, index) => (
                handlePeopleBio(item.email, item.name, item.position, item.id)
            )
            )
        }
      }

    


    const handlePeopleBio = (email, name, pos, id) =>{
        setPosition(pos)
        setSelectedPeopleName(name)
        setNameFlag(false)
        setEmployeeId(id)
        setEmployeeName(name)
        setEmployeeEmail(email)
    }
  
    const formatDate = (value) => {
        if (!value || value == '') return '';
        return moment(value).format();
      }

      const handleInputStartDate = (date) => {
        setStartDateTime(date);
        return;
    }

    
    const handleInputEndDate = (date) => {
        setEndDateTime(date);
        return;
    }

    const handleCanceled = () => {
        handleCloseModal()

    }
    return(
        <>
        <AdminLayout>
            <Breadcrumbs
            pageTitle='Edit New Task Delegation'
            itemList={[
                {
                    title : '',
                    href: '/edit-task-delegation'
                }
                
            ]}
            />
            <Card>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Select Task</p>
                    <FormGroup>
                            <Select
                            isDisabled
                            name="Select Task"
                            value={selectedTaskType}
                            onChange={handleTaskSelect}
                            options={optionsTaskType}
                            menuPortalTarget={document.body}
                            menuShouldScrollIntoView = {false}
                            maxMenuHeight={230}
                            />
                           
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Delegation Unit</p>
                    <FormGroup>
                            <Select
                            isDisabled = {true}
                            name="DelegationUnit"
                            placeholder = "Select Unit"
                            value={selectedunitName}
                            onChange={handleUnitSelect}
                            options={optionsUnitType}
                            menuPortalTarget={document.body}
                            menuShouldScrollIntoView = {false}
                            maxMenuHeight={230}
                            />
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Delegated Employee Name</p>
                    <FormGroup>
                        <Input
                        name="people"
                        placeholder='Select People'
                        value={selectedpeopleName}
                        onChange={(e) => (handleSearchPeople(e.target.value))}
                        onKeyDown={handleKeyDownSearch}
                        type='text'
                        />
                        {nameflag &&
                        <ul
                        style={{
                            listStyleType: 'none',
                            paddingLeft: 0,
                            position: 'absolute',
                            zIndex: 1000,
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            width: '100%'
                        }}>
                            {employees.map((item, index) => (
                                <li key={index}
                                onClick={() => handlePeopleBio(item.email, item.name, item.position, item.id)}>
                                {item.name}
                            </li>
                            ))}
                        </ul>
                        }
                    </FormGroup>
                </div>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Position of Delegated Employee</p>
                    <FormGroup>
                        <Input
                        name="position"
                        value={position}
                        placeholder="Position"
                        disabled={true}
                        type="text"
                        />
                    </FormGroup>
                </div>
                <Container fluid="sm" style={{marginLeft: 0, paddingLeft: 0}}>
                <Row>
                    <Col style={{marginRight: 0}}>
                        <div className='select-wrapper'>
                        <p className="font-weight-bold">Start Date</p>
                        <FormGroup>
                                <DateTimePicker
                                clearable
                                disabled={started}
                                value={startDateTime}
                                label="Pick date and time"
                                placeholder="Pick date and time"
                                onChange={handleInputStartDate}
                                size="md"
                                style={{width: '200px'}}
                                />      
                        </FormGroup>
                        </div>
                    </Col>
                    <Col>
                        <div className='select-wrapper'>
                        <p className="font-weight-bold">End Date</p>
                        <FormGroup>
                                <DateTimePicker
                                clearable
                                value={endDateTime}
                                label="Pick date and time"
                                placeholder="Pick date and time"
                                onChange={handleInputEndDate}
                                size="md"
                                style={{width: '200px'}}
                                />      
                                </FormGroup>
                        </div>
                    </Col>
                </Row>
                </Container>
                <div className='select-wrapper'>
                <p className="font-weight-bold">Reason Update <span style={{ color: 'red' }}>*</span></p>
                    <FormGroup>
                        <Input
                        name="reasonUpdate"
                        value={reasonUpdate}
                        placeholder="Reason"
                        type="text"
                        onChange={(e) => (handleReason(e.target.value))}
                        />
                       {error && <p style={{ color: 'red' }}>{error}</p>}
                    </FormGroup>
                </div>
                <Row className='submit-button-div'>
                    <Button color='purple' onClick={handleSubmitData}>
                        Update
                    </Button>
                </Row>
            </Card>
        </AdminLayout>

        <ModalConfirmation
        isVisible = {modalDialog.opened && modalDialog.type == 'submission'}
        type='submit'
        onCancel={handleCloseModal}
        onConfirm={handleSave}
        />
         </>
        
    );
};

export default EditTaskDelegation;